import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { BUSINESS } from '../constants/business';

const TermsOfService: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Service — {BUSINESS.displayName}</title>
        <meta name="description" content={`Terms of service for ${BUSINESS.displayName}. Review the terms and conditions for using our website and services.`} />
        <link rel="canonical" href={`${BUSINESS.siteUrl}/terms-of-service`} />
      </Helmet>

      <Box sx={{ py: { xs: 6, md: 8 }, backgroundColor: '#f9fafb' }}>
        <Container maxWidth="md">
          <Typography variant="h1" sx={{ mb: 4, fontSize: { xs: '2rem', md: '2.5rem' }, fontWeight: 700, color: '#1f2937' }}>
            Terms of Service
          </Typography>

          <Typography variant="body2" sx={{ mb: 4, color: '#6b7280' }}>
            Last updated: April 2026
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <section>
              <Typography variant="h5" sx={{ mb: 2, fontWeight: 600, color: '#1e3a8a' }}>
                Acceptance of Terms
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.7, color: '#374151' }}>
                By accessing and using the {BUSINESS.displayName} website (madtitle.pro), you agree to be bound
                by these Terms of Service. If you do not agree to these terms, please do not use our website.
              </Typography>
            </section>

            <section>
              <Typography variant="h5" sx={{ mb: 2, fontWeight: 600, color: '#1e3a8a' }}>
                Services Description
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.7, color: '#374151' }}>
                {BUSINESS.displayName} provides title insurance, title search, real estate closing, and related
                settlement services in the State of New Jersey. Information on this website is provided for general
                informational purposes and does not constitute legal advice. All title services are subject to
                separate service agreements.
              </Typography>
            </section>

            <section>
              <Typography variant="h5" sx={{ mb: 2, fontWeight: 600, color: '#1e3a8a' }}>
                Website Use
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.7, color: '#374151' }}>
                You agree to use this website only for lawful purposes. You may not use this website in any way
                that could damage, disable, or impair the website or interfere with any other party's use of the
                website. The content on this website, including text, graphics, and logos, is the property of
                {BUSINESS.legalName} and is protected by copyright law.
              </Typography>
            </section>

            <section>
              <Typography variant="h5" sx={{ mb: 2, fontWeight: 600, color: '#1e3a8a' }}>
                Disclaimer
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.7, color: '#374151' }}>
                The information on this website is provided "as is" without warranties of any kind. While we
                strive to keep information accurate and up to date, we make no representations about the
                completeness, accuracy, or reliability of any information on this website. Calculators and
                estimators on this site provide approximate figures and should not be relied upon as exact costs.
              </Typography>
            </section>

            <section>
              <Typography variant="h5" sx={{ mb: 2, fontWeight: 600, color: '#1e3a8a' }}>
                Limitation of Liability
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.7, color: '#374151' }}>
                {BUSINESS.legalName} shall not be liable for any damages arising from the use of or inability
                to use this website or any information provided on it. This limitation applies to direct,
                indirect, incidental, and consequential damages.
              </Typography>
            </section>

            <section>
              <Typography variant="h5" sx={{ mb: 2, fontWeight: 600, color: '#1e3a8a' }}>
                Governing Law
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.7, color: '#374151' }}>
                These terms shall be governed by and construed in accordance with the laws of the State of
                New Jersey, without regard to conflict of law provisions.
              </Typography>
            </section>

            <section>
              <Typography variant="h5" sx={{ mb: 2, fontWeight: 600, color: '#1e3a8a' }}>
                Contact Us
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.7, color: '#374151' }}>
                If you have questions about these terms, please contact us at {BUSINESS.contact.email} or
                call {BUSINESS.contact.phoneDisplay}.
              </Typography>
            </section>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default TermsOfService;
